import {
  Pipe,
  PipeTransform
} from '@angular/core';
import { PolishDeclination } from '../services/polish-declination';

@Pipe({name: 'simCartFormat'})
export class SimCartFormatPipe implements PipeTransform {
  transform(_simCartNumber: number): string {
    const declinations: Array<string> = [
      'karta',
      'karty',
      'kart'
    ];

    return _simCartNumber + ' ' + PolishDeclination(_simCartNumber, declinations);
  }
}
